import React, { useCallback, useEffect, useState } from 'react';
import { AppRemixIcon, AppTextArea } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import { axiosPath } from '../../../../routing/helpers/router';
import colors from '../../../../constants/colors';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import Translator from '../../../components/helpers/Translator';
import useIsMounted from '../../../components/hooks/useIsMounted';
import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';
import errorHandler from '../../../components/error/ErrorHandler';

export default function QuestionType7(props) {
  const { question } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const userAnswers = useSelector((state) => state.currentPage?.answers);
  const pendingQuestions = useSelector(
    (state) => state.currentPage?.pendingQuestions
  );
  const [isLoading, setIsLoading] = useState(false);
  const [tempAnswer, setTempAnswer] = useState(
    userAnswers?.[question.id]?.[0] || ''
  );

  useEffect(() => {
    setTempAnswer(userAnswers?.[question.id]?.[0] || '');
  }, [question, userAnswers]);

  // > QUESTION CHANGE
  const loadPlantObligationForm = useCallback(async () => {
    setIsLoading(true);
    axios
      .post(
        axiosPath(
          "api_r_user_m_legalCompliance_plantObligationForm_question_change"
        ),
        {
          type: 7,
          moduleBridgeHex,
          plantHex,
          questionID: question.id,
          answer: tempAnswer || [],
        }
      )
      .then((r) => {
        if (isMounted.current) {
          dispatch(
            currentPageAction.change("answers", r.data?.userAnswers, true)
          );
          dispatch(
            currentPageAction.change(
              "pendingQuestions",
              r.data.pendingQuestions,
              true
            )
          );
          setIsLoading(false);
        }
      })
      .catch((e) => {
        dispatch(errorHandler(e));
      });
  }, [moduleBridgeHex, plantHex, question, tempAnswer]);
  // < QUESTION CHANGE

  return (
    <QuestionGroup>
      <Question>
        <h3>
          <AppRemixIcon
            icon="timer-2"
            color={
              pendingQuestions?.includes(question.id)
                ? colors.state2
                : colors.grey200
            }
            filled={pendingQuestions?.includes(question.id)}
            title={
              pendingQuestions?.includes(question.id)
                ? ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="to.be.calculated"
                    />
                  )
                : ''
            }
            className="mr-1"
          />
          {question.name}
        </h3>
        <textarea
          className="form-control"
          value={tempAnswer}
          onBlur={() => loadPlantObligationForm()}
          onChange={(v) => setTempAnswer(v.target.value)}
        />
      </Question>
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}

const Question = styled.div`
  margin: 20px 0;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
`;
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;